import { render, staticRenderFns } from "./Repository.vue?vue&type=template&id=cb6f76f8"
import script from "./Repository.vue?vue&type=script&lang=js"
export * from "./Repository.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports